import Page from '@/components/Page';
import {DataTableRpc} from '@/components/dataTableRpc';

/**
 * Leaderboard page for speculators
 * @returns {JSX.Element}
 */
function SpeculatorLeaderboard() {
  return (
    <Page currentPage="Leaderboard">
      <div className="flex flex-col gap-6 lg:flex-row">
        <div className="lg:w-full">
          <DataTableRpc
            title="Top Recruiters (1k)"
            functionName="get_top_recruiters"
            columns={[
              {
                field: 'recruiter_rank',
                header: 'Rank',
              },
              {
                field: 'recruiter_username',
                header: 'Username',
                render: row => row.recruiter_username ?? 'Anonymous',
              },
              {
                field: 'registration_count',
                header: 'Registrations',
              },
            ]}
            sortOptions={[
              {
                column: 'registration_count',
                direction: 'desc',
                label: 'Most Registrations',
                default: true,
              },
              {
                column: 'recruiter_rank',
                direction: 'asc',
                label: 'Rank',
              },
            ]}
            limit={50}
            hideAdd
            enabled={true}
          />
          <DataTableRpc
            title="Top Market Makers (1k)"
            functionName="get_top_market_movers"
            columns={[
              {
                field: 'market_mover_rank',
                header: 'Rank',
              },
              {
                field: 'speculator_username',
                header: 'Username',
                render: row => row.speculator_username ?? 'Anonymous',
              },
              {
                field: 'total_position_volume',
                header: 'Total Volume ($)',
                render: row => `$${row.total_position_volume.toLocaleString()}`,
              },
              {
                field: 'total_position_count',
                header: 'Total Positions',
              },
            ]}
            sortOptions={[
              {
                column: 'total_position_volume',
                direction: 'desc',
                label: 'Highest Volume',
                default: true,
              },
              {
                column: 'total_position_count',
                direction: 'desc',
                label: 'Most Positions',
              },
            ]}
            limit={50}
            hideAdd
            enabled={true}
          />
          <DataTableRpc
            title="Top Retailers (100)"
            functionName="get_top_retailers"
            columns={[
              {
                field: 'retailer_rank',
                header: 'Rank',
              },
              {
                field: 'retailer_name',
                header: 'Retailer Name',
                render: row => row.retailer_name ?? 'Unknown Retailer',
              },
              {
                field: 'total_position_volume',
                header: 'Total Volume ($)',
                render: row => `$${Number(row.total_position_volume).toLocaleString()}`,
              },
              {
                field: 'total_position_count',
                header: 'Total Positions',
              },
            ]}
            sortOptions={[
              {
                column: 'total_position_volume',
                direction: 'desc',
                label: 'Highest Volume',
                default: true,
              },
              {
                column: 'total_position_count',
                direction: 'desc',
                label: 'Most Positions',
              },
            ]}
            limit={50}
            hideAdd
            enabled={true}
          />
          <DataTableRpc
            title="Top Distributors (100)"
            functionName="get_top_distributors"
            columns={[
              {
                field: 'distributor_rank',
                header: 'Rank',
              },
              {
                field: 'distributor_name',
                header: 'Distributor Name',
                render: row => row.distributor_name ?? 'Unknown Distributor',
              },
              {
                field: 'total_position_volume',
                header: 'Total Volume ($)',
                render: row => `$${Number(row.total_position_volume).toLocaleString()}`,
              },
              {
                field: 'total_position_count',
                header: 'Total Positions',
              },
            ]}
            sortOptions={[
              {
                column: 'total_position_volume',
                direction: 'desc',
                label: 'Highest Volume',
                default: true,
              },
              {
                column: 'total_position_count',
                direction: 'desc',
                label: 'Most Positions',
              },
            ]}
            limit={50}
            hideAdd
            enabled={true}
          />
          <DataTableRpc
            title="Top Brands (100)"
            functionName="get_top_brands"
            columns={[
              {
                field: 'brand_rank',
                header: 'Rank',
              },
              {
                field: 'brand_name',
                header: 'Brand Name',
                render: row => row.brand_name ?? 'Unknown Brand',
              },
              {
                field: 'total_position_volume',
                header: 'Total Volume ($)',
                render: row => `$${Number(row.total_position_volume).toLocaleString()}`,
              },
              {
                field: 'total_position_count',
                header: 'Total Positions',
              },
            ]}
            sortOptions={[
              {
                column: 'total_position_volume',
                direction: 'desc',
                label: 'Highest Volume',
                default: true,
              },
              {
                column: 'total_position_count',
                direction: 'desc',
                label: 'Most Positions',
              },
            ]}
            limit={50}
            hideAdd
            enabled={true}
          />
        </div>
      </div>
    </Page>
  );
}

export default SpeculatorLeaderboard;
